import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Product} from "../../product-details/interface/product";
import {SizeProfile} from "../../product-details/interface/size-profile";
import {SizeProfileOptionItem} from "../../product-details/interface/size-profile-option-item";
import {CustomSizeProfile} from "../../product-details/interface/custom-size-profile";
import {ProductSizeProfileList} from "../../product-details/interface/product-size-profile-list";
import {MatDialog} from "@angular/material/dialog";
import {ProductSizeGuideDialogComponent} from "../product-size-guide-dialog/product-size-guide-dialog.component";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";

@Component({
	selector: 'fb-product-size-profile',
	standalone: true,
	imports: [CommonModule, FormsModule, ReactiveFormsModule],
	templateUrl: './product-size-profile.component.html',
	styleUrls: ['./product-size-profile.component.scss']
})
export class ProductSizeProfileComponent implements OnChanges {

	@Input()
	public product: Product = {} as Product;
	@Input()
	public sizeProfile: SizeProfile = {} as SizeProfile;
	public selectedSizeLabel: string = '';
	public selectedSize: SizeProfileOptionItem = {} as SizeProfileOptionItem;
	public showCustomOptions: boolean = false;
	public customSizeFormGroup: FormGroup = new FormGroup({});
	public showErrorMessage: boolean = false;
	public customSizeSubmitted: boolean = false;

	@Output()
	public sizeSelected = new EventEmitter<SizeProfileOptionItem>();

	@Output()
	public customSizeSelected = new EventEmitter<any>();

	constructor(
		private _dialog: MatDialog
	) {
	}

	ngOnChanges() {
		this.sizeProfile.sizeProfileOptionList = this.sizeProfile.sizeProfileOptionList
			.sort((a,b) => a.sortOrder - b.sortOrder);
		this.selectDefaultSize();
		if(this.product.customSizeProfileEnabled && this.product.customSizeProfile) {
			this.product.customSizeProfile.customSizeProfileItemList.forEach(item => {
				if(item.mandatory) {
					this.customSizeFormGroup.addControl(item.label, new FormControl('',[Validators.required]));
				}
				else {
					this.customSizeFormGroup.addControl(item.label, new FormControl('',[]));
				}
			});
		}
	}

	public selectSize(size: SizeProfileOptionItem): void {
		this.selectedSizeLabel = size.label;
		this.selectedSize = size;
		this.showCustomOptions = false;
		this.sizeSelected.emit(this.selectedSize);
		this.customSizeFormGroup.reset();
		this.customSizeSubmitted = false;
		this.customSizeSelected.emit(null);
	}

	public selectDefaultSize(): void {
		let size: ProductSizeProfileList | undefined = undefined;
		if(this.product.productSizeProfileList && this.product.productSizeProfileList.length > 0) {
			 size = this.product.productSizeProfileList
				.filter(size => !size.disabled)
				.find(size => size.quantity > 0);
		}
		if(size) {
			this.selectedSize = size.sizeProfileOption;
		}
		else {
			this.selectedSize = this.sizeProfile.sizeProfileOptionList[0];
		}
		this.sizeSelected.emit(this.selectedSize);
		this.selectedSizeLabel = this.selectedSize.label;
	}

	public selectCustom(customSizeProfile: CustomSizeProfile) {
		this.selectedSizeLabel = "custom";
		this.showCustomOptions = true;
		this.selectedSize = {} as SizeProfileOptionItem;
	}

	public openSizeGuideDialog(): void {
		let position = {};
		let height: string = '90vh';
		let maxWidth: string = '900px';
		if(this.product.productGroup !== 'finished') {
			position = {
				top: '0',
				right: '0'
			};
			height = '100vh';
			maxWidth = '400px';
		}
		this._dialog.open(ProductSizeGuideDialogComponent, {
			id: 'size-guide-dialog',
			width: '96vw',
			maxWidth: maxWidth,
			maxHeight: height,
			position: position,
			data: {
				productGroup: this.product.productGroup,
				sizeProfile: this.sizeProfile
			}
		});
	}

	public onCustomSizeSubmit(): void {
		if(this.customSizeFormGroup.valid) {
			this.showCustomOptions = false;
			this.customSizeSelected.emit(this.customSizeFormGroup.value);
			this.customSizeSubmitted = true;
		}
		else {
			this.showErrorMessage= true;
			this.customSizeSubmitted = false;
		}
	}
}
